import { Logger } from './log'

export function getClient ({ $config, $axios, store, $log }) {
  const logger = new Logger('Public API')

  const api = $axios.create({ timeout: 30000 })
  api.defaults.log = true

  const runtimeConfig = $config.axios || {}
  const baseURL = process.browser ? runtimeConfig.publicBrowserBaseURL : runtimeConfig.publicBaseURL
  api.setBaseURL(baseURL)

  api.onRequest((config) => {
    // Track when the request is being made
    config.meta = config.meta || {}
    config.meta.requestStartedAt = new Date().getTime()

    if (!process.server && (config.progress || config.progress === undefined)) {
      config.meta.uid = Math.floor(Math.random() * (new Date()))
      store.commit('page/REQUEST_START', [config.meta.uid, config.timeout])
    }

    if (config.log) logger.debug(`${config.method.toUpperCase()} ${config.url}`)
  })

  api.onResponse((response) => {
    // Log how long this request took
    const requestTime = ((new Date().getTime()) - response.config.meta.requestStartedAt) / 1000
    if (response.config.log) logger.debug(`${response.config.method.toUpperCase()} ${response.config.url} ${response.status} ${response.statusText} in ${requestTime}s`)

    if (response.config && response.config.meta.uid) store.commit('page/REQUEST_FINISH', response.config.meta.uid)
  })

  api.onError((error) => {
    if (error.config && error.config.meta.uid) store.commit('page/REQUEST_FINISH', error.config.meta.uid)
  })

  api.quietGet = async (path, options) => {
    return await api.get(path, { progress: false, ...options })
  }

  api.$quietGet = async (path, options) => {
    return await api.$get(path, { progress: false, ...options })
  }

  api.quietPost = async (path, payload, options) => {
    return await api.post(path, payload, { progress: false, ...options })
  }

  return api
}

export default function (context, inject) {
  const api = getClient(context)

  // Inject to context as $publicAPI
  inject('publicAPI', api)
}